import React from "react"
import { isEmpty } from "lodash"
import Button from "components/common/Button"
import MediaPlayer from "components/common/MediaPlayer"
import moment from "moment"
import "./index.scss"

let jitsiContainerId = "jitsi-container-id"

class ClassForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      jitsi: {},
      mediaProgress: {
        loaded: 0,
        loadedSeconds: 0,
        played: 0,
        playedSeconds: 0,
      },
    }
  }

  loadJitsiScript = () => {
    let resolveLoadJitsiScriptPromise = null

    const loadJitsiScriptPromise = new Promise((resolve) => {
      resolveLoadJitsiScriptPromise = resolve
    })

    const script = document.createElement("script")
    script.src = "https://studios.apptitude.xyz/external_api.js"
    script.async = true
    script.onload = () => resolveLoadJitsiScriptPromise(true)
    document.body.appendChild(script)

    return loadJitsiScriptPromise
  }

  initialiseJitsi = async () => {
    const { coursewareDetails, userInfo } = this.props
    if (!window.JitsiMeetExternalAPI) {
      await this.loadJitsiScript()
    }
    var userDetails = userInfo || {}
    var roomName = coursewareDetails?.schedule?.slug || coursewareDetails.slug
    const _jitsi = new window.JitsiMeetExternalAPI("studios.apptitude.xyz", {
      parentNode: document.getElementById(jitsiContainerId),
      roomName: roomName,
      userInfo: {
        email: userDetails.email || "",
        displayName: userDetails.full_name || "",
      },
      onload: function () {
        _jitsi.executeCommand("subject", coursewareDetails.module_name)
      },
    })

    this.setState({ jitsi: _jitsi })
  }

  componentDidMount() {
    // this.initialiseJitsi();
  }

  componentDidUpdate() {}

  getMediaProgress = (value) => {
    this.setState({ mediaProgress: value })
  }

  render() {
    const { coursewareDetails, toggleJoinClass } = this.props

    const startDate = `${coursewareDetails?.conference_room?.date} ${coursewareDetails?.conference_room?.start_time}`

    const isDisabledJoinClass = moment().diff(moment(startDate), "minutes")

    return (
      <>
        <div className="courseware-details mt-l">
          <h2 className="courseware-title">{`${coursewareDetails.name}`}</h2>
          {coursewareDetails.description && (
            <p className="courseware-description">
              {coursewareDetails.description}
            </p>
          )}
        </div>

        {coursewareDetails?.conference_room && (
          <div className="courseware-details">
            {coursewareDetails?.conference_room?.name && (
              <p className="label-title">
                {coursewareDetails?.conference_room?.name}
              </p>
            )}

            <div className="class-details">
              <p className="label-name">Date: </p>
              <p>{coursewareDetails?.conference_room?.date}</p>
            </div>

            <div className="class-details">
              <p className="label-name">Time: </p>
              <p>{`${coursewareDetails?.conference_room?.start_time} - ${coursewareDetails?.conference_room?.end_time}`}</p>
            </div>
          </div>
        )}
        <div className="room-container" title={coursewareDetails.name}>
          <p className="text">
            You are required to attend this class. This requirement will be
            marked as completed once the instructor checked your attendance.
          </p>
          <Button
            label="Join Class"
            onClick={toggleJoinClass}
            disabled={isDisabledJoinClass < -15}
          />
          <p className="notation">
            You can join 15 mins before the class starts.
          </p>
          {!isEmpty(coursewareDetails.recording) && (
            <div className="room-recording">
              <hr />
              <p>Class Recording</p>
              <MediaPlayer
                type="video"
                media={`${coursewareDetails.recording}`}
                onGetMediaProgress={this.getMediaProgress}
                forwardStreaming
              />
            </div>
          )}
        </div>
      </>
    )
  }
}

export default ClassForm
